document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  forms.forEach((form) => {
    const variantInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('button[name="add"]');

    if (!variantInput || !addButton) return;

    const buttonContainer =
      addButton.closest(".product-form__buttons") || form;

    const buttonTextElement =
      addButton.querySelector("span") || addButton;

    const originalButtonText =
      buttonTextElement.textContent.trim() || "Add to Cart";

    const removeAlreadyInCartMessage = () => {
      buttonContainer
        .querySelector(".pinnacle-already-in-cart-message")
        ?.remove();
    };

    const restoreAddToCartButton = () => {
      removeAlreadyInCartMessage();

      buttonTextElement.textContent = originalButtonText;
      addButton.disabled = false;
      addButton.style.opacity = "";
      addButton.style.cursor = "";
      addButton.style.pointerEvents = "";
    };

    const showAlreadyInCart = () => {
      buttonTextElement.textContent = "✓ Already in Cart";

      addButton.disabled = true;
      addButton.style.opacity = "0.75";
      addButton.style.cursor = "default";

      let cartMessage = buttonContainer.querySelector(
        ".pinnacle-already-in-cart-message"
      );

      if (cartMessage) return;

      cartMessage = document.createElement("div");
      cartMessage.className = "pinnacle-already-in-cart-message";

      cartMessage.innerHTML = `
        <p style="
          margin: 18px 0 18px;
          text-align: center;
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 14px;
          line-height: 1.5;
          color: #1B5E3F;
        ">
          This item is already in your cart. Review your cart or continue shopping.
        </p>

        <button
          type="button"
          class="pinnacle-view-cart-button"
          style="
            position: relative;
            z-index: 10;
            display: block;
            width: 100%;
            box-sizing: border-box;
            padding: 14px 18px;
            background: #1B5E3F;
            color: #D4AF37;
            border: 2px solid #D4AF37;
            border-radius: 8px;
            text-align: center;
            font-family: Georgia, 'Times New Roman', serif;
            font-size: 16px;
            font-weight: 700;
            line-height: 1.2;
            cursor: pointer;
            pointer-events: auto;
            touch-action: manipulation;
          "
        >
          View Cart
        </button>
      `;

      buttonContainer.appendChild(cartMessage);

      const viewCartButton = cartMessage.querySelector(
        ".pinnacle-view-cart-button"
      );

      viewCartButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        window.location.assign("/cart");
      });
    };

    const isSelectedVariantInCart = async () => {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          headers: {
            Accept: "application/json"
          },
          cache: "no-store"
        });

        if (!response.ok) return false;

        const cart = await response.json();
        const selectedVariantId = Number(variantInput.value);

        return cart.items.some(
          (item) => Number(item.variant_id) === selectedVariantId
        );
      } catch (error) {
        console.log("Already-in-cart check failed", error);
        return false;
      }
    };

    const updateProductForm = async () => {
      const alreadyInCart = await isSelectedVariantInCart();

      if (alreadyInCart) {
        showAlreadyInCart();
      } else {
        restoreAddToCartButton();
      }
    };

    updateProductForm();

    variantInput.addEventListener("change", updateProductForm);

    addButton.addEventListener(
      "click",
      async (event) => {
        const alreadyInCart = await isSelectedVariantInCart();

        if (alreadyInCart) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          showAlreadyInCart();
        }
      },
      true
    );
  });
});